import React, { createContext, useState, useEffect } from "react";
import ScholarshipService from "../services/ScholarshipService";

export const LoginContext = createContext(false);

export const LoginContextProvider = ({ children }) => {
    const [ user, setUser ] = useState({});
  
    useEffect(() => {
        ScholarshipService.getUser()
        .then(response => {
            setUser(response.data)
        })
    }, []);
  
    return (
      // the Provider gives access to the context to its children
      <LoginContext.Provider value={ user }>
        {children}
      </LoginContext.Provider>
    );
};